 
import * as constants from "../../../constants";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import CommonUtilities from "../Utils/CommonUtilities";
import EntryForm from "./EntryForm";


const InvoicesPayments = () => {
  const { t } = useTranslation();
  const translate = t as (key: string) => string;
  const transactionTypes = CommonUtilities.invoiceTransactionTypes;
  const AdminProfile = useSelector((state: RootState) => state.participantAdminProfile);
  return (
    <EntryForm
      accountType={true}
      methodOfPayment={true}
      participantField={true}
      commentsField={true}
      typeOfTransactions={true}
      dateOfTransactions={true}
      checkReferenceField={true}
      amountField={true}
      creditLineClose={false}
      transactionTypes={transactionTypes}
      headingMessage={translate('invoicesPayments')}
      pageType="invoicesPayments"
      navigationPath={AdminProfile.participantAdminProfile === constants.ADMIN_VIEW ? "/invoicesPaymentsTransactions" : "/invoicesPaymentsTransactions"}
    />
  );
};

export default InvoicesPayments;
